import { useContext } from "react";
import { CartContext } from "../context/CartContext";

function Cart() {
  const { cart, removeFromCart, clearCart } = useContext(CartContext);

  async function handleCheckout() {
    const res = await fetch("/api/create-checkout-session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cart }),
    });
    const { url } = await res.json();
    window.location = url;
  }

  if (cart.length === 0) return <div className="page-container">Cart is empty.</div>;

  return (
    <div className="page-container">
      <h1>Your Cart</h1>
      <ul>
        {cart.map((p, i) => (
          <li key={i}>
            {p.name} — {p.price}
            <button onClick={() => removeFromCart(p.id)}>Remove</button>
          </li>
        ))}
      </ul>
      <button onClick={handleCheckout}>Checkout</button>
      <button onClick={clearCart} style={{ marginLeft: 8 }}>Clear Cart</button>
    </div>
  );
}

export default Cart;